import React, { useContext, useEffect,  useState } from 'react';
import { Datagrid, Icon, Button, Link } from "@abb/abb-common-ux-react";
import { RootContext } from "../../../contexts/root-context";
import UserSession from "../../../components/Authentication/user-session";
import ProoferForm from '../../../components/proofer-tool-cmps/popup-form/proofer-form';
import ProoferTabs from '../../../components/proofer-tool-cmps/popup-output-tabs/popup-output-tabs';
import axios from 'axios';
import Navbar from '../../../components/Navbar/navbar';
import "./dashboard.css";
import jsonSchema from './dashboard-schema.json'
import { isJsonValidSchema, validateJsonSchema } from "../../../util.js";
import PropTypes from 'prop-types';
import { getToken } from '../../../components/Authentication/get-token';
function isBlank(str) {
    return str === null || str === undefined || (typeof str === 'string' && /^\s*$/.test(str));
}

function TestComp({ i, processStatus }) {

    React.useEffect(() => {
        return () => {
      
        };
    }, []);

    return (
        <>
            {i === "Enquiry Document RFQ 1.pdf"? (
                <Icon name="abb/check-mark" style={{ marginRight: '16px' }} onClick={() => alert(`Status completed on ${i}`)} />
            ) : (
                <Icon name="abb/hour-glass" style={{ marginRight: '16px' }} onClick={() => alert(`Status is pending on  ${i}`)} />
            )}
        </>
    );
}


TestComp.propTypes = {
    processStatus: PropTypes.string, // Adjust type as per actual data type
    i: PropTypes.number,           // Adjust type as per actual data type
  };
  

const MemoizedTestComp = React.memo(TestComp);

function ProoferDashboard() {
    const [showDialog, setShowDialog] = useState(false); // State to control dialog visibility
    const [allDocsData, setAllDocsData] = useState([]);
    const [data, setData] = React.useState([]);
    const { currentProoferState, setcurrentProoferState } = useContext(RootContext);
    const postRequestUrlPrefix = "https://api.dev.mod.cognien.abb/proofer/";

    const getProoferDashboardAllDocs = async () => {
        let requestURL = postRequestUrlPrefix + "doc/all";
        axios.get(requestURL, getToken())
            .then((response) => {
                const docs = response.data["documents"];
                // Check if docs is an array, otherwise wrap it into an array
                if (Array.isArray(docs)) {
                    setAllDocsData(docs);
                    setRecordsforDatagrid();
                } else if (docs && typeof docs === 'object') {
                    setAllDocsData([docs]); // Wrap single object into an array
                    setRecordsforDatagrid();
                } else {
                    console.error("Unexpected API response:", docs);
                    setAllDocsData([]); // Set empty array if the response is unexpected
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(() => {

            });
    }
    useEffect(() => {

        getProoferDashboardAllDocs();
        // }
    }, []);

    // useEffect(() => {
    //     const jsonString = JSON.stringify(jsonSchema)
    //     if (isJsonValidSchema(jsonString)) {
    //       console.log('JSON being validated:', jsonSchema);
    //       validateJsonSchema(jsonSchema); // Pass ignored properties
    //     } else {
    //       console.error('Invalid JSON syntax: Missing braces or commas.');
    //     }
    //   }, []);
    

    const showSummary=(fname)=>{
        
        localStorage.setItem("current-doc-id",fname)
        setcurrentProoferState("showtabs")
    }



    const setRecordsforDatagrid = () => {
        // Make sure allDocsData is an array
        if (!Array.isArray(allDocsData)) {
            console.error("allDocsData is not an array:", allDocsData);
            return;
        }

        const transformedData = allDocsData?.map((doc, i) => ({
            rowId: doc.id,
            fields: {
                filename: ( <Link
                    href=""
                    onClick={() => showSummary(doc.id)}
                    
                  >{doc.name}</Link>),

                  
                oppname: doc.metadata.oppno,
                projname: doc.metadata.project,
                custname: doc.metadata.customername,
                prodgroup: doc.metadata.productgroup,
                uploadedat: doc.metadata.createdon,
                state: (
                    <div>
                        <MemoizedTestComp key={`TestComp-${doc.name}`} i={doc.name} processStatus={doc.process_status} />
                    </div>
                ),
            },

           
            isSelected: i % 4 === 0 ? null : false,
            disableSelect: i % 5 === 0,
            rowStatus: i % 7,
            fieldStatuses: { Value: i % 7 },
        }));

        

        setData(transformedData);
        setRowCount(transformedData.length);
    };

    function createProoferForm() {
        setShowDialog(true);
        setcurrentProoferState("create-form");
    }

    const initialColumns = React.useMemo(() => {
        const columns = [
            jsonSchema?.properties?.columns?.filename?.enable && {
                fieldKey: 'filename',
                title: jsonSchema.properties.columns.filename.title,
            },
            jsonSchema?.properties?.columns?.oppname?.enable && {
                fieldKey: 'oppname',
                title: jsonSchema.properties.columns.oppname.title,
            },
            jsonSchema?.properties?.columns?.projname?.enable && {
                fieldKey: 'projname',
                title: jsonSchema.properties.columns.projname.title,
            },
            jsonSchema?.properties?.columns?.custname?.enable && {
                fieldKey: 'custname',
                title: jsonSchema.properties.columns.custname.title,
            },
            jsonSchema?.properties?.columns?.prodgroup?.enable && {
                fieldKey: 'prodgroup',
                title: jsonSchema.properties.columns.prodgroup.title,
            },
            jsonSchema?.properties?.columns?.uploadedat?.enable && {
                fieldKey: 'uploadedat',
                title: jsonSchema.properties.columns.uploadedat.title,
            },
            {
                fieldKey: 'state',
                title: jsonSchema.properties.columns.state.title,
        
            },
        ];
    
        return columns.filter(Boolean); // Removes any falsy values like undefined or false
    }, [jsonSchema]);
    

    const [rowCount, setRowCount] = React.useState(1);
    const [currentPage, setCurrentPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);

    const [columns] = React.useState(initialColumns);
    const [footerStyle] = React.useState('columns');
    const [columnedFooterData] = React.useState(
        initialColumns.reduce((acc, c) => {
            acc[c.fieldKey] = `Footer: ${c.title}`;
            return acc;
        }, {})
    );
    const [freeFooterData] = React.useState(
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <span>Some footer content here...</span>
            <span>...and more content here.</span>
        </div>
    );
    const [sortOrder, setSortOrder] = React.useState("desc");
    const [columnOrder, setColumnOrder] = React.useState(undefined);
    const [columnFilters, setColumnFilters] = React.useState(() => {

        const filters = {};
    

        if (jsonSchema.properties.columns.oppname.placeholder.enable) {
            filters.oppname = { value: '', placeholder: jsonSchema.properties.columns.oppname.placeholder.value || 'Opportunity Name' };
        }
        if (jsonSchema.properties.columns.projname.placeholder.enable) {
            filters.projname = { value: '', placeholder: jsonSchema.properties.columns.projname.placeholder.value || 'Project Name' };
        }
        if (jsonSchema.properties.columns.custname.placeholder.enable) {
            filters.custname = { value: '', placeholder: jsonSchema.properties.columns.custname.placeholder.value || 'Customer Name' };
        }
        if (jsonSchema.properties.columns.prodgroup.placeholder.enable) {
            filters.prodgroup = { value: '', placeholder: jsonSchema.properties.columns.prodgroup.placeholder.value || 'Product Group' };
        }
    
        return filters;
    });
    
    const [hideColumnFilters, setHideColumnFilters] = React.useState(false);

    const handleColumnFilterChange = (newFilters) => {
        setColumnFilters(newFilters);
        const filteredData = data
            .map((c) => ({ ...c }))
            .filter((c) => {
                return (
                    // (isBlank(newFilters.filename.value) || ('' + c.fields.filename).toLowerCase().indexOf(newFilters.filename.value.toLowerCase()) > -1) &&
                    (isBlank(newFilters.oppname.value) || ('' + c.fields.oppname).toLowerCase().indexOf(newFilters.oppname.value.toLowerCase()) > -1) &&
                    (isBlank(newFilters.projname.value) || ('' + c.fields.projname).toLowerCase().indexOf(newFilters.projname.value.toLowerCase()) > -1) &&
                    (isBlank(newFilters.custname.value) || ('' + c.fields.custname).toLowerCase().indexOf(newFilters.custname.value.toLowerCase()) > -1) &&
                    (isBlank(newFilters.prodgroup.value) || ('' + c.fields.prodgroup).toLowerCase().indexOf(newFilters.prodgroup.value.toLowerCase()) > -1)

                );
            });
        setData(filteredData);
        setRowCount(filteredData.length);
        setCurrentPage(0);
    };

    const handleSelectRow = (rowIndex) => {
        setData(
            data.map((d, i) => Object.assign(d, { isSelected: rowIndex === i ? !d.isSelected : d.isSelected }))
        );
    };
  

    return (
        <>
            <UserSession />
            <Navbar />

            {currentProoferState == "showtabs" ? <ProoferTabs /> :
                <>
                    <div className="proofer-header-container">
                        <div className="col-5 col-m-12 col-s-12">
                        {jsonSchema.properties.navbar.subheading.enable && (
                            <div className="filter-header-proofer">{jsonSchema.properties.navbar.subheading.title}</div>
                        )}
                        </div>
                        <div className="col-7 col-m-12 col-s-12">
                            {/* {startTS} To {endTS} */}
                            <div className="filters-group row filterflexes">
                            {jsonSchema.properties.navbar.refresh.enable && (
                                <Icon id="ic-refresh" sizeClass='large' name="abb/refresh" style={{ marginRight: '16px',marginTop:"5px", color: "white" }} onClick={getProoferDashboardAllDocs} />
                            )}
                                {jsonSchema.properties.navbar.Generate.enable && (
                                <Button className="button-width"
                                    text={jsonSchema.properties.navbar.Generate.text}
                                    onClick={() => createProoferForm()}
                                    shape="pill"
                                    type="primary-red"
                                />
                                )}

                            </div>
                        </div>
                    </div>
                    {showDialog && currentProoferState == "create-form" ? <ProoferForm showDialog={showDialog} setShowDialog={setShowDialog} /> : ""}
                    {currentProoferState == "showtabs" ? <ProoferTabs showDialog={showDialog} setShowDialog={setShowDialog} /> : ""}

                    <Datagrid
                        id='proofer-datagrid'
                        className="ABB_CommonUX_Datagrid__dark"
                        columns={columns}
                        columnFilters={columnFilters}
                        hideColumnFilters={hideColumnFilters}
                        footerStyle={footerStyle}
                        columnedFooterData={columnedFooterData}
                        freeFooterData={freeFooterData}
                        data={data}
                        rowCount={rowCount}
                        onSelectRow={handleSelectRow}
                        sortOrder={sortOrder}
                        enableSorting={true}
                        columnOrder={columnOrder}
                        setSortOrder={setSortOrder}
                        setColumnOrder={setColumnOrder}
                        pageSize={pageSize}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        onPageSizeChange={setPageSize}
                        hasSelectAll={true}
                        onColumnFiltersChange={handleColumnFilterChange}
                        onClickColumnFiltersIcon={() => setHideColumnFilters(!hideColumnFilters)}
                        onClickClearColumnFilters={() => {
                            const newFilters = { ...columnFilters };
                            Object.keys(newFilters).forEach((k) => {
                                newFilters[k].value = '';
                            });
                            handleColumnFilterChange(newFilters);
                            setHideColumnFilters(true);
                        }}
                        
                        customMessage={data.length !== 0 ? undefined : jsonSchema.properties.columns.custmessage.title}

                    /> </>}

        </>

    );
}

export default ProoferDashboard;